import { render, staticRenderFns } from "./PDFViewer2.vue?vue&type=template&id=cbbcaf1a&"
import script from "./PDFViewer2.vue?vue&type=script&lang=js&"
export * from "./PDFViewer2.vue?vue&type=script&lang=js&"
import style0 from "./PDFViewer2.vue?vue&type=style&index=0&id=cbbcaf1a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports